// Copyright (c) Mysten Labs, Inc. — DGC: LOCAL uses same RPC as VITE_CPC_RPC_URL (not :9124)
// SPDX-License-Identifier: Apache-2.0

import { useSuiClient } from '@mysten/dapp-kit';
import { SuiClient, SuiHTTPTransport } from '@mysten/sui.js/client';
import { useMemo } from 'react';

import { useNetwork } from '~/context';
import { Network, NetworkConfigs } from '~/utils/api/DefaultRpcClient';

export function useEnhancedRpcClient() {
	const [network] = useNetwork();
	const client = useSuiClient();
	const enhancedRpc = useMemo(() => {
		if (network === Network.LOCAL) {
			const url = NetworkConfigs[Network.LOCAL].url;
			return new SuiClient({ transport: new SuiHTTPTransport({ url }) });
		}

		return client;
	}, [network, client]);

	return enhancedRpc;
}
